'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('TenantDetailsCtrl', TenantDetailsCtrl);

  TenantDetailsCtrl.$inject = ['$state', '$location', 'Auth', 'errorMessageService', 'update',
    'Constants', 'tenant', 'Tenant', 'users', 'User', 'dialogType', 'Labels', '$mdDialog', 'sgAutocompleteHelpers'
  ];

  function TenantDetailsCtrl ($state, $location, Auth, errorMessageService, update,
    Constants, tenant, Tenant, users, User, dialogType, Labels, $mdDialog, sgAutocompleteHelpers) {
    /**
     * Controller constants
     * */
    const vm = this;
    vm.tenant = tenant;
    vm.type = dialogType; // template used to display the correct template
    vm.userLanguages = Constants.getList('USER_LANGUAGES');
    vm.users = users;
    vm.selectedUsers = [];
    vm.updateParent = update;
    vm.LABELS = Labels;

    vm.panelTitleKey = {
      detail: 'tenantedit',
      delete: 'tenantdelete',
      copy: 'tenantcopy',
      new: 'tenantaddnew'
    };

    /**
     * Update data
     * */
    vm.update = (updatedUsers = vm.users, updatedTenant = vm.tenant) => {

      vm.activeUsers = updatedUsers.filter((user) => user.activated && user.active);

      if (vm.type === 'new') {
        initializeAutoCompleteFields(updatedUsers);
      } else {
        const availableUsers = vm.activeUsers.filter((u) =>
          updatedTenant.users.findIndex((tu) => tu._id === u._id) === -1);

        initializeAutoCompleteFields(availableUsers);

        vm.selectedUsers = updatedTenant.users.map((user) => {
          const tenantUser: any = {};
          tenantUser._id = user._id;
          tenantUser.fullName = user.fullName;

          return tenantUser;
        });
      }
    };

    vm.getPanelTitle = (type) => vm.panelTitleKey[type] || '';

    const initializeAutoCompleteFields = (availableUsers) => {
      vm.usersField = {
        fieldType: 'dropdown',
        label: vm.LABELS.getPlural('adduser'),
        required: false,
        onChange: addingUserToTenant,
        options: availableUsers,
        optionsMapping: {
          displayNameKey: 'fullName',
        },
        helpKey: 'users',
        searchTextChanged: true,
        nonAlphabetical: false
      };
    };

    /**
     * Controller initialization
     * */
    vm.$onInit = () => {
      vm.panelTitle = vm.getPanelTitle(vm.type);
      vm.filter = sgAutocompleteHelpers.filter;
      vm.update(vm.users);
    };

    /**
     * User interactions
     * */
    const addingUserToTenant = (value, item) => {
      if (angular.isObject(item) && !vm.selectedUsers.includes(item)) {
        vm.selectedUsers.push(item);
      }

      vm.usersField.searchValue = '';
    };

    vm.filesChangedCb = (allFiles) => {
      vm.tenant.uploads = allFiles;
    };

    /**
     * removeUserFromTenant
     * Function should be used to remove an user.
     * @param {Object} selectedUser
     * @param {Object} selectedTenant
     */
    // TODO use vm.update
    vm.removeUserFromTenant = (selectedUser, selectedTenant) => {
      let selectedTenantUser = selectedTenant.users.find((user) => user._id === selectedUser._id);

      selectedTenantUser.databases = selectedTenantUser.databases.filter((db) => db !== selectedTenant.name);

      const updateRemovedUser = {
        _id: selectedTenantUser._id,
        user: selectedTenantUser
      };

      const userFullName = updateRemovedUser.user.fullName;

      User.update(updateRemovedUser).$promise.then((updatedUsers) => {
        selectedTenant.users = selectedTenant.users.filter((tenantUser) => tenantUser._id !== updateRemovedUser._id);
        errorMessageService.showToast(
          vm.LABELS.getLabelPlaceholder('userremovedfromtennant', {name: userFullName}),
          true
        );
        vm.update(updatedUsers, selectedTenant);
      });
    };

    vm.close = () => {
      $mdDialog.cancel();
    };


    /**
     * @param {Object} form -
     */
    vm.submit = (form) => {
      if (form.$valid) {
        // Differentiate between create/adding a tenant
        if (vm.type === 'new') {
          vm.tenant.name = vm.tenant.name.replace(/\s+/g, '-').toLowerCase();

          return Tenant.createTenant({ tenant: vm.tenant }).$promise
            .then((createdTenant) => updateTenantUsers(createdTenant, vm.selectedUsers))
            .then(({ updatedUsers, newTenant }) => {
              vm.tenant = vm.updateParent(newTenant, updatedUsers);
              vm.update(updatedUsers);
              $mdDialog.hide();
            });
        } else if (vm.type === 'detail') {
          // We need to make sure that we're updating the newly selected users
          let usersToUpdate = vm.selectedUsers.filter((newUser) => angular.isArray(newUser.databases));

          return Tenant.updateTenant({ _id: tenant._id, tenant: vm.tenant }).$promise
            .then((updatedTenant) => updateTenantUsers(updatedTenant, usersToUpdate))
            .then(({ updatedUsers, newTenant }) => {
              vm.tenant = vm.updateParent(newTenant, updatedUsers);
              vm.update(updatedUsers);
              $mdDialog.hide();
            })
            .catch($mdDialog.cancel);


        }
      }
      return $mdDialog.hide();
    };

    /**
     * @function updateTenantUsers
     * @param {Object} tenantObj - created/updated tenant object
     * @param {Object[]} usersToUpdate - The array containing the selected users
     */
    const updateTenantUsers = (tenantObj, usersToUpdate) => {
      const filteredUsers = usersToUpdate.filter((user) => !user.databases.includes(tenantObj.name));

      const promises = [];
      filteredUsers.forEach((user) => {
        user.databases.push(tenantObj.name);

        promises.push(User.updateOne({
          noresult: 'true'
        }, {
          _id: user._id,
          user: user
        }).$promise);
      });

      return Promise.all(promises)
        .then((results) => {
          if (results.length > 0) {
            return User.getAll({ tenantUsers: 'true' }).$promise;
          }
          return Promise.resolve([]);
        })
        .then((updatedUsers) =>
          Promise.resolve({
            updatedUsers,
            newTenant: tenantObj
          })
        );
    };
  }
})();
